import { widgetSettings } from '@keen.io/widgets';

var createCardSettings = function createCardSettings() {
  var enabled = widgetSettings.card.enabled;
  return {
    card: {
      enabled: enabled
    }
  };
};

export default createCardSettings;